import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HRManagementDashboard from "../hr_management/HRManagementDashboard";
import FormPageHeader from "../admin/quizSystem/components/FormPageHeader";

const HRManagement = () => {
  const [t] = useTranslation();
  const [customerId, setCustomerId] = useState(null);
  const [organisationId, setOrganisationId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const cid = localStorage.getItem("customer_id");
      const oid = localStorage.getItem("organisation_id");

      if (cid && oid) {
        setCustomerId(cid);
        setOrganisationId(oid);
        setLoading(false);
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  const canViewHRManagement = ["17", "144"].includes(String(customerId));

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          width: "100%",
        }}
      >
        <div style={{ color: "red", fontSize: "2rem", fontWeight: "bold" }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[93vh] overflow-auto bg-white p-3 text-[#20232A] sm:p-4">
      <FormPageHeader title={t("userMenuSidebar.label.HR-management")} />

      {canViewHRManagement ? (
        <HRManagementDashboard
          organisationId={Number(organisationId)}
          customerId={customerId}
        />
      ) : (
        <div className="p-3" style={{ textAlign: "center" }}>
          Organisation does not have permission
        </div>
      )}
    </div>
  );
};

export default HRManagement;
